import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/index/1.png'


const _withScopeId = n => (_pushScopeId("data-v-0a7e3e84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max" }
const _hoisted_2 = { class: "row1" }
const _hoisted_3 = { class: "container mx-auto" }
const _hoisted_4 = { class: "flex h-10 nr cy md:justify-between" }
const _hoisted_5 = { class: "hidden md:block" }
const _hoisted_6 = { class: "h-full cy" }
const _hoisted_7 = { class: "h-full cy" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "指南", -1))
const _hoisted_9 = { class: "h-full ml-5 cy" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "span-bt",
  "data-bs-toggle": "modal",
  "data-bs-target": "#myModal"
}, "兑换优惠券", -1))
const _hoisted_11 = { class: "h-full cy" }
const _hoisted_12 = { class: "h-full cy" }
const _hoisted_13 = { class: "h-full cy" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "优惠券", -1))
const _hoisted_15 = { class: "h-full ml-5 cy" }
const _hoisted_16 = { class: "h-full cy" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "游客", -1))
const _hoisted_18 = { class: "h-full ml-5 cy" }
const _hoisted_19 = { class: "h-full cy" }
const _hoisted_20 = { class: "h-full ml-5 cy" }
const _hoisted_21 = { class: "h-full cy" }
const _hoisted_22 = { class: "row2 sm:h-32" }
const _hoisted_23 = { class: "cc" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "md:w-10/12 sm:w-22",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_25 = {
  class: "h-12 w-16 cc",
  style: {"background-color":"#2ED87B"}
}
const _hoisted_26 = { class: "cc flex flex-col" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 购物车 ", -1))
const _hoisted_28 = { class: "cc flex flex-col ml-9" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, " 收藏 ", -1))
const _hoisted_30 = {
  class: "modal",
  id: "myModal"
}
const _hoisted_31 = { class: "modal-dialog" }
const _hoisted_32 = { class: "modal-content" }
const _hoisted_33 = { class: "modal-header" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "modal-title" }, "兑换优惠券", -1))
const _hoisted_35 = { class: "modal-body" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "1、兑换码获取：参与京东活动有机会获得优惠券兑换码。兑换码由16位数字和字母组合而成。", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "2、兑换码使用：在当前页面输入兑换码即可兑换相应优惠券。一个兑换码只能兑换一张优惠券，不可重复使用。", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "3、提示：输入兑换码时请使用英文输入法。", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "bt-exchange w-full pt-2 pb-2"
}, "立即兑换", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Postcard = _resolveComponent("Postcard")!
  const _component_User = _resolveComponent("User")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Search = _resolveComponent("Search")!
  const _component_ShoppingCart = _resolveComponent("ShoppingCart")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_Star = _resolveComponent("Star")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Close = _resolveComponent("Close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_icon, {
                  size: "20",
                  color: "#2ED87B"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionFilled)
                  ]),
                  _: 1
                }),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_icon, {
                  size: "20",
                  color: "#2ED87B"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Postcard)
                  ]),
                  _: 1
                }),
                _hoisted_10
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_icon, {
                  size: "20",
                  color: "#2ED87B"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Postcard)
                  ]),
                  _: 1
                }),
                _hoisted_14
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_icon, {
                  size: "20",
                  color: "#2ED87B"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_User)
                  ]),
                  _: 1
                }),
                _hoisted_17
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_icon, {
                  size: "20",
                  color: "#2ED87B"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Lock)
                  ]),
                  _: 1
                }),
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: "/login" }, {
                    default: _withCtx(() => [
                      _createTextVNode("登录")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_icon, {
                  size: "20",
                  color: "#2ED87B"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_User)
                  ]),
                  _: 1
                }),
                _createElementVNode("span", null, [
                  _createVNode(_component_router_link, { to: "/register" }, {
                    default: _withCtx(() => [
                      _createTextVNode("注册")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_el_row, { class: "container mx-auto h-full el-row" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            class: "col cc h-full",
            xs: 24,
            sm: 5
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            class: "col cc h-full mt-0 sm:mt-0",
            xs: 24,
            sm: 14
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: $data.value1,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.value1) = $event)),
                placeholder: "输入关键字...",
                class: "input-with-select h-12",
                style: {"border-radius":"0"}
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_el_icon, {
                  style: {},
                  size: "24",
                  color: "#fff"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Search)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            class: "col cc h-full flex justify-end mt-0 sm:mt-0",
            xs: 24,
            sm: 5
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_badge, {
                value: 12,
                class: "item"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/cars" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_el_icon, {
                          style: {},
                          size: "35",
                          color: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ShoppingCart)
                          ]),
                          _: 1
                        }),
                        _hoisted_27
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/user/likes" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_el_icon, {
                      style: {},
                      size: "35",
                      color: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Star)
                      ]),
                      _: 1
                    }),
                    _hoisted_29
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(_component_el_icon, {
              class: "btn-close",
              "data-bs-dismiss": "modal"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _hoisted_37,
            _hoisted_38,
            _createVNode(_component_el_input, {
              modelValue: $data.value2,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.value2) = $event)),
              placeholder: "请输入16位兑换码",
              class: "input-with-select h-10 mb-2",
              style: {"border-radius":"0"}
            }, null, 8, ["modelValue"]),
            _hoisted_39
          ])
        ])
      ])
    ])
  ]))
}